module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-5-a726972347bc648a017d7ebbe6715687.webp";